import React from 'react';
import s from './ModalHeadingText.scss';
/**
 * The heading text we use for modals.
 */
var ModalHeadingText = function (_a) {
    var children = _a.children;
    // TODO: Use <Heading /> once a11y heading component is in da-ds
    return React.createElement("h2", { className: s['root'] }, children);
};
ModalHeadingText.displayName = 'ModalHeadingText';
export default ModalHeadingText;
//# sourceMappingURL=ModalHeadingText.js.map